import { LoginService } from "./../../../services/login/login.service";
import { OrdenesServiceService } from "./../../../services/ordenes/ordenes-service.service";
import { Apollo } from "apollo-angular";
import { Subscription } from "rxjs";
import {
  Component,
  OnInit,
  OnDestroy,
  EventEmitter,
  Output,
} from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";
import { createOT } from "./../../../models/graphQL/mutations/createOt.mutation";
import {
  FormGroup,
  FormControl,
  FormBuilder,
  Validators,
} from "@angular/forms";
import * as _ from "lodash";

@Component({
  selector: "app-orders-modal",
  templateUrl: "./orders-modal.component.html",
})
export class OrdersModalComponent implements OnInit, OnDestroy {
  addNewOrderForm: FormGroup;
  response: Subscription;
  maestros: any;
  disps: any;
  loadingMaestros: boolean;
  loadingDisps: boolean;
  orden: string;
  colada: string;
  clave: string;
  modelo: any;
  dispUUID: string;
  disp: string;
  bono: string;
  @Output() toastRequest = new EventEmitter();

  constructor(
    public dialogRef: MatDialogRef<OrdersModalComponent>,
    public apollo: Apollo,
    private ordenesService: OrdenesServiceService,
    private formBuilder: FormBuilder,
    private loginService: LoginService
  ) {}

  ngOnInit() {
    this.constructFormBuilders();
    this.findDataToLoadCreationModal();
  }

  doGenerateFormControls() {
    this.addNewOrderForm.addControl(
      "orden",
      new FormControl({ value: "", disabled: false })
    );
    this.addNewOrderForm.addControl(
      "colada",
      new FormControl({ value: "", disabled: false })
    );
    this.addNewOrderForm.addControl(
      "clave",
      new FormControl({ value: "", disabled: false })
    );
    this.addNewOrderForm.addControl("modelo", new FormControl(""));
    this.addNewOrderForm.addControl("hornoNombre", new FormControl(""));
    this.addNewOrderForm.addControl("bono", new FormControl(""));
  }

  constructFormBuilders() {
    this.addNewOrderForm = this.formBuilder.group({
      usuario: [this.loginService.currentUserValue.name, [Validators.required]],
      usuarioUUID: [
        this.loginService.currentUserValue.uuid,
        [Validators.required],
      ],
      orden: [this.orden, [Validators.required]],
      colada: [this.colada, [Validators.required]],
      clave: [this.clave, [Validators.required]],
      modelo: [this.modelo, [Validators.required]],
      dispUUID: [this.dispUUID, [Validators.required]],
      bono: [this.bono, [Validators.required]],
      // ,
      // disp: [this.data.id._id, [Validators.required]]
    });
  }

  findDataToLoadCreationModal() {
    this.ordenesService.findDataMaestros().subscribe(({ data, loading }) => {
      this.maestros = data.findMaestros;
      this.loadingMaestros = loading;
    });
    this.ordenesService.findDispositivos().subscribe(({ data, loading }) => {
      this.disps = data.findDispositivos;
      this.loadingDisps = loading;
    });
  }

  createOT() {
    this.apollo
      .mutate({
        mutation: createOT,
        fetchPolicy: "no-cache",
        variables: {
          orden: this.addNewOrderForm.value.orden,
          modelo: _.omit(
            this.maestros.filter(
              (r) => r.modelo == this.addNewOrderForm.value.modelo
            )[0],
            ["__typename", "_id"]
          ),
          colada: this.addNewOrderForm.value.colada,
          clave: this.addNewOrderForm.value.clave,
          dispUUID: this.addNewOrderForm.value.dispUUID,
          disp: this.disps.filter(
            (r) => r.uuid == this.addNewOrderForm.value.dispUUID
          )[0].nombre,
          hornoNombre: this.addNewOrderForm.value.hornoNombre,
          estado: "ot_not_started",
          bono: this.addNewOrderForm.value.bono,
        },
      })
      .subscribe(({ data }) => {
        this.toastRequest.next(data);
      });
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  ngOnDestroy() {}
}
